import React from 'react';
import {
  CardCvcElement,
  CardElement,
  CardExpiryElement,
  CardNumberElement,
  ElementProps,
} from '@stripe/react-stripe-js';
import { StripeCardElementOptions, StripeElementStyle } from '@stripe/stripe-js';
import { withStripeStyle } from 'housecall-ui';

type Props = ElementProps & {
  cardElementStyle: StripeElementStyle;
  options?: StripeCardElementOptions;
};

const StripeCardElement = (props: Props) => (
  <CardElement {...props} options={{ style: props.cardElementStyle, ...props.options }} />
);
export const HousecallCardElement = withStripeStyle()(StripeCardElement);

const StripeCardExpiryElement = (props: Props) => (
  <CardExpiryElement {...props} options={{ placeholder: '', style: props.cardElementStyle, ...props.options }} />
);
export const HousecallCardExpiryElement = withStripeStyle()(StripeCardExpiryElement);

const StripeCardCvcElement = (props: Props) => (
  <CardCvcElement {...props} options={{ placeholder: '', style: props.cardElementStyle, ...props.options }} />
);
export const HousecallCardCvcElement = withStripeStyle()(StripeCardCvcElement);

const StripeNumberElement = (props: Props) => (
  <CardNumberElement {...props} options={{ placeholder: '', style: props.cardElementStyle, ...props.options }} />
);
export const HousecallCardNumberElement = withStripeStyle()(StripeNumberElement);
